export type TagPropType = {
  value?: string;
  destination?: string;
  id?: string;
  tagClass?: string;
};

export default function Tags({
  value,
  destination,
  id,
  tagClass,
}: TagPropType) {
  return (
    <span
      data-testid={id}
      className={twMerge(
        "bg-neutral-200 px-[10px] py-[3px] not-italic text-[12px] lg:text-[12px] leading-[150%] text-neutral-700",
        tagClass,
      )}
    >
      <a href={`/${removeLeadingSlash(destination || "")}`}>{value}</a>
    </span>
  );
}

export type TagsProps = {
  tagsWrapper?: string;
  tagClass?: string;
  tags?: {
    alias?: string;
    name?: string;
  }[];
};
import { removeLeadingSlash } from "@helper/removeTrailingLeadingSlash";
import { twMerge } from "tailwind-merge";

export const RenderTags = ({ tags, tagClass, tagsWrapper }: TagsProps) => {
  return Array.isArray(tags) && tags[0]?.alias ? (
    <div
      className={twMerge("flex gap-2 flex-wrap", tagsWrapper)}
      data-testid="tag-wrapper"
    >
      {tags.map(({ alias, name }, index) =>
        alias ? (
          <Tags
            key={index}
            destination={alias}
            value={name}
            id={`tag-${index}`}
            tagClass={tagClass}
          />
        ) : null,
      )}
    </div>
  ) : null;
};
